import { flow, makeObservable } from 'mobx';
import BaseStore from './BaseStore';
import { FileApi } from '../apis';

class FileStore extends BaseStore {

    constructor(rootStore) {
        super(rootStore);
        makeObservable(this, {
            uploadFile: flow.bound
        })
        this.rootStore = rootStore;
        this.api = new FileApi();
    }

    *uploadFile(url, payload, { onUploadProgress, onSuccess, onError, onFinish }, isShowLoading = true) {
        try {
            isShowLoading && this.rootStore.apiStore.showLoading();
            yield this.api.uploadFile({ url, payload, onUploadProgress });
            if (onSuccess) {
                onSuccess();
                isShowLoading && this.rootStore.apiStore.hideLoading();
            }
        } catch (error) {
            if (onError) onError();
        } finally {
            if (onFinish) onFinish();
        }
    }
}

export default FileStore;